import { PageTypeEnum } from '@/constant';

export const LIST_SHOW_MAPPING_APPLICANT = [
	PageTypeEnum.FRANCHISE,
	PageTypeEnum.LODGING,
	PageTypeEnum.RECOMMENDER,
];

export const LIST_SHOW_MAPPING_FRANCHISE = [
	PageTypeEnum.APPLICANT,
	PageTypeEnum.CHANGE_WORK_PLACE,
	PageTypeEnum.PROGRAM,
];

export const getShowConfigs = (pageType: PageTypeEnum) => {
	const isShowApplicantMappings =
		LIST_SHOW_MAPPING_APPLICANT.includes(pageType);
	const isShowFranchiseMappings =
		LIST_SHOW_MAPPING_FRANCHISE.includes(pageType);

	return {
		isShowApplicantMappings,
		isShowFranchiseMappings,
	};
};
